// Shared helpers for region (bölge) management

// Normalizes province names so map data ("Hakkâri") matches stored İl values ("Hakkari")
export const normalizeCity = (value) =>
  (value || '')
    .toString()
    .toLocaleLowerCase('tr-TR')
    .replace(/â/g, 'a')
    .replace(/î/g, 'i')
    .replace(/û/g, 'u')
    .trim();

export const REGION_COLORS = [
  '#3b82f6', // blue
  '#10b981', // emerald
  '#f59e0b', // amber
  '#ef4444', // red
  '#8b5cf6', // violet
  '#ec4899', // pink
  '#14b8a6', // teal
  '#f97316', // orange
  '#6366f1', // indigo
  '#84cc16', // lime
  '#06b6d4', // cyan
  '#a855f7'  // purple
];

// Finds the region a city belongs to (city name compared with normalization)
export const findRegionByCity = (regions, cityName) => {
  const normalized = normalizeCity(cityName);
  if (!normalized) return null;
  return (
    regions.find((region) =>
      (region.cities || []).some((city) => normalizeCity(city) === normalized)
    ) || null
  );
};

export const normalizeManagerIds = (value) => {
  if (Array.isArray(value)) {
    return value.filter(Boolean);
  }
  return value ? [value] : [];
};

export const getCityManagerIds = (region, cityName) => {
  if (!region || !cityName) return [];
  const key = normalizeCity(cityName);
  return normalizeManagerIds(region.cityManagerIds?.[key]);
};

export const getResponsibleManagerIds = (region, cityName) => {
  const cityManagers = getCityManagerIds(region, cityName);
  return cityManagers.length > 0
    ? cityManagers
    : normalizeManagerIds(region?.managerId);
};

export const managerIdsInclude = (managerIds, employeeId) =>
  normalizeManagerIds(managerIds).includes(employeeId);
